module.exports = __webpack_public_path__ + "static/media/carousel_onions_1.0a51e390.jpg";